/* KONG TICKER — vanilla, no deps.
   Simulated numbers are derived from the clock, never Math.random(): a reload inside the same
   time slot shows the same value, so the bar never "jumps" in front of a customer. */
(() => {
  const REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // FNV-1a — tiny deterministic hash
  const hash = (str) => { let h = 2166136261; for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; };
  // Share of peak traffic by local hour (evenings are busiest)
  const CURVE = [.3, .22, .18, .15, .15, .18, .28, .42, .55, .62, .68, .72, .76, .74, .72, .74, .8, .86, .92, .98, 1, .96, .82, .55];
  const dayKey = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
  const lines = (s) => (s || '').split(/<br\s*\/?>/i).map((x) => x.trim()).filter(Boolean);

  function scramble(el, to) {
    const target = String(to);
    if (REDUCE || el.textContent === target) { el.textContent = target; return; }
    let n = 0;
    const tick = () => {
      if (n++ >= 8) { el.textContent = target; return; }
      el.textContent = target.replace(/\d/g, () => String((Math.random() * 10) | 0));   // visual noise only
      setTimeout(tick, 45);
    };
    tick();
  }

  function init(root) {
    if (root.dataset.tkInit) return;
    root.dataset.tkInit = '1';
    const track = root.querySelector('[data-tk-track]');
    const viewport = root.querySelector('.tk__viewport');
    const groups = track ? track.querySelectorAll('.tk__group') : [];
    root.style.setProperty('--tk-dur', (parseInt(root.dataset.speed, 10) || 45) + 's');

    // Make each copy at least as wide as the bar so the loop never shows a gap
    if (groups.length === 2 && groups[0].children.length) {
      const base = Array.from(groups[0].children);
      let guard = 0;
      while (groups[0].scrollWidth < viewport.clientWidth && guard++ < 6) {
        base.forEach((node) => { groups[0].appendChild(node.cloneNode(true)); groups[1].appendChild(node.cloneNode(true)); });
      }
    }

    /* ---- visitors lane ---- */
    const visitors = () => {
      const now = new Date();
      root.querySelectorAll('[data-tk-visitors]').forEach((el) => {
        const base = +el.dataset.base || 38, spread = +el.dataset.spread || 0;
        const slot = Math.floor((now.getHours() * 60 + now.getMinutes()) / 5);
        const jitter = spread ? (hash(dayKey(now) + ':v:' + slot) % (2 * spread + 1)) - spread : 0;
        const v = Math.max(3, Math.round(base * CURVE[now.getHours()] + jitter));
        if (el.dataset.v !== String(v)) { el.dataset.v = String(v); scramble(el, v); }
      });
    };

    /* ---- recent purchase lane ---- */
    const purchase = () => {
      const now = Date.now(), SLOT = 7 * 60 * 1000;
      const slot = Math.floor(now / SLOT), into = Math.floor((now % SLOT) / 60000);
      root.querySelectorAll('[data-tk-purchase]').forEach((el) => {
        const products = lines(el.dataset.productLines), cities = lines(el.dataset.cities);
        const out = el.querySelector('[data-tk-purchase-text]');
        if (!products.length || !cities.length || !out) return;
        const p = products[hash('p' + slot) % products.length];
        const c = cities[hash('c' + slot) % cities.length];
        const m = 2 + (hash('m' + slot) % 9) + into;
        const text = (el.dataset.template || '{producto}').replace('{ciudad}', c).replace('{producto}', p).replace('{min}', m);
        if (out.textContent !== text) out.textContent = text;
      });
    };

    visitors(); purchase();
    setInterval(visitors, 30000);
    setInterval(purchase, 60000);

    /* ---- pause toggle (WCAG 2.2.2) ---- */
    const pauseBtn = root.querySelector('[data-tk-pause]');
    if (pauseBtn) pauseBtn.addEventListener('click', () => {
      const on = !root.classList.contains('is-paused');
      root.classList.toggle('is-paused', on);
      pauseBtn.setAttribute('aria-pressed', String(on));
      pauseBtn.setAttribute('aria-label', on ? 'Reanudar avisos' : 'Pausar avisos');
    });

    /* ---- marquee reacts to scroll velocity (#9) ---- */
    if (!REDUCE && track && track.getAnimations) {
      let anim = null, lastY = scrollY, lastT = performance.now(), rate = 1, raf = 0;
      const decay = () => {
        rate += (1 - rate) * 0.06;
        if (anim) anim.playbackRate = rate;
        raf = Math.abs(rate - 1) > 0.01 ? requestAnimationFrame(decay) : 0;
        if (!raf && anim) anim.playbackRate = 1;
      };
      addEventListener('scroll', () => {
        anim = anim || track.getAnimations()[0];
        const t = performance.now(), dt = Math.max(t - lastT, 16);
        const v = Math.abs(scrollY - lastY) / dt * 1000;           // px per second
        lastY = scrollY; lastT = t;
        rate = Math.max(rate, 1 + Math.min(v / 700, 3));
        if (anim) anim.playbackRate = rate;
        if (!raf) raf = requestAnimationFrame(decay);
      }, { passive: true });
    }
  }

  const boot = () => document.querySelectorAll('[data-tk]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { const r = e.target.querySelector('[data-tk]'); if (r) { r.dataset.tkInit = ''; init(r); } });
})();
